import {
  ChakraFlex,
  FAIconName,
  InputGroupV2,
  TextInputV2,
} from '@equip.health/ui';

import {
  InquiryFilterValue,
  TextInputV2Type,
} from '~/lib/constants/inquiry.constants';

interface MinMaxFilterProps {
  id: string;
  label: string;
  max: InquiryFilterValue;
  min: InquiryFilterValue;
  setMax: (status: string) => void;
  setMin: (status: string) => void;
}

const MinMaxFilter = ({
  id,
  max,
  min,
  label,
  setMax,
  setMin,
}: MinMaxFilterProps) => {
  const TOP_LEVEL_ID = `${id}__min-max-filter`;
  return (
    <InputGroupV2 id={TOP_LEVEL_ID} label={label}>
      <ChakraFlex gap="12px">
        <TextInputV2
          id={`${TOP_LEVEL_ID}__min-input`}
          leftIcon={FAIconName.arrowFromBottom}
          onChange={setMin}
          placeholder="Min"
          type={TextInputV2Type.NUMBER}
          value={(min as string) ?? ''}
        />
        <TextInputV2
          id={`${TOP_LEVEL_ID}__max-input`}
          leftIcon={FAIconName.arrowFromTop}
          onChange={setMax}
          placeholder="Max"
          type={TextInputV2Type.NUMBER}
          value={(max as string) ?? ''}
        />
      </ChakraFlex>
    </InputGroupV2>
  );
};

export default MinMaxFilter;
